import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import { getFormatDate } from '../../../utilities/dateUtils';

const GenericGuideUpdateDate = (props) => {
    const [updateDate, setUpdateDate] = useState('');

    useEffect(() => {
        async function fetchData() {
            let content = await EpiContext.loadContentByPath(window.location.pathname);            
            getUpdateDate(content);
          }
          fetchData();
    }, []);

    return (
        <div className='generic-guide-update-date'>
            { updateDate && <> המדריך עודכן ב: {updateDate} </> }            
        </div>
    );

    function getUpdateDate(content) {
        let lastDate = content.mainContentArea.expandedValue.length > 0 ? new Date(content.mainContentArea.expandedValue[0].saved) : null;

        content.mainContentArea.expandedValue.forEach(element => {
            const blockDate = new Date(element.saved);
            //console.info(lastDate.toString() + ' lastDate');
            //console.info(new Date(element.saved).toString());
            if(blockDate > lastDate){
                lastDate = blockDate;
            }
        });

        if (lastDate) {
            setUpdateDate(getFormatDate(lastDate));
        }        
    }

};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideUpdateDate);